export default "__VITE_ASSET__BXlUpnS9__"